import { render } from "./EditQuestions.vue?vue&type=template&id=79dc792c"
import script from "./EditQuestions.vue?vue&type=script&lang=js"
export * from "./EditQuestions.vue?vue&type=script&lang=js"

import "./EditQuestions.vue?vue&type=style&index=0&id=79dc792c&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__